import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, AlertTriangle, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

// « Enregistrer et envoyer au centre » : un seul e-mail récapitulatif des nouveaux documents
export const EnregistrerDocuments = ({ nbEnAttente, endpoint, onEnvoye }) => {
  const [envoi, setEnvoi] = useState(false);

  const enregistrer = async () => {
    setEnvoi(true);
    try {
      const { data } = await axios.post(endpoint);
      toast.success(data.message);
      onEnvoye?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi au centre");
    } finally {
      setEnvoi(false);
    }
  };

  if (nbEnAttente === 0) {
    return (
      <p className="mt-6 flex items-center gap-2 text-sm text-green-700" data-testid="documents-tous-envoyes">
        <CheckCircle className="h-4 w-4" />
        Tous vos documents déposés ont été envoyés au centre.
      </p>
    );
  }

  return (
    <div className="mt-6 rounded-lg border-2 border-amber-300 bg-amber-50 p-4" data-testid="documents-a-enregistrer">
      <p className="flex items-start gap-2 text-sm text-amber-900">
        <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
        <span>
          <strong>{nbEnAttente} document{nbEnAttente > 1 ? 's' : ''} pas encore envoyé{nbEnAttente > 1 ? 's' : ''} au centre.</strong>{' '}
          Quand vous avez fini de déposer vos documents, cliquez sur « Enregistrer et envoyer au centre ».
        </span>
      </p>
      <Button
        onClick={enregistrer}
        disabled={envoi}
        className="mt-3 w-full sm:w-auto bg-[#8DC63F] hover:bg-[#7db336] text-white"
        data-testid="btn-enregistrer-documents"
      >
        {envoi ? (
          <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full mr-2" />
        ) : (
          <Send className="h-4 w-4 mr-2" />
        )}
        Enregistrer et envoyer au centre
      </Button>
    </div>
  );
};
